import type { ReactNode } from "react";
import { AVATAR_PLACEHOLDER_STYLE, avatarInitials } from "@/lib/avatar";

// Person result row (extended search, search overlay). Extracted from
// ExtendedSearchPage so the styleguide can show it as part of the card
// taxonomy; behaviour and markup are unchanged.
export function ResultCard({
  title,
  sub,
  avatar,
  actions,
  onOpen,
  embedded = false,
}: {
  title: string;
  sub: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  avatar?: any;
  actions?: ReactNode;
  onOpen?: () => void;
  embedded?: boolean;
}) {
  const clickable = Boolean(onOpen);
  return (
    <div
      className={`flex items-center gap-3 p-3 ${embedded ? "bg-page box-flat" : "bg-surface box"} ${clickable ? "group cursor-pointer transition hover:ring-accent-decoration/40" : ""}`}
      onClick={onOpen}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === "Enter") onOpen?.();
            }
          : undefined
      }
    >
      {avatar !== undefined ? (
        <div className="h-11 w-11 shrink-0 overflow-hidden rounded-full ring-1 ring-ink/5">
          {avatar?.content ? (
            <img
              src={`data:${avatar.mimeType || "image/jpeg"};base64,${avatar.content}`}
              alt=""
              className="h-full w-full object-cover"
            />
          ) : (
            <div
              className="flex h-full w-full items-center justify-center font-serif text-smycles-body"
              style={AVATAR_PLACEHOLDER_STYLE}
            >
              {avatarInitials(title)}
            </div>
          )}
        </div>
      ) : null}
      <div className="min-w-0 flex-1">
        <div
          className={`truncate text-smycles-body text-ink ${clickable ? "transition group-hover:text-ink-accent" : ""}`}
        >
          {title || "–"}
        </div>
        {sub ? <div className="truncate text-smycles-meta text-ink-muted">{sub}</div> : null}
      </div>
      {actions ? (
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          {actions}
        </div>
      ) : null}
    </div>
  );
}
